<template>
  <div class="material-specific-info-card">
    <tabs :tabs="tabs" :active-tab="activeTab" :tabs-styling="tabsStyling" :tabs-labels-styling="tabsLabelsStyling"
      :center-tabs="false" @startTabChange="activeTab = $event" />
    <div v-if="tabs[activeTab].id === 'company'" :style="{ 'height': tabContentHeight }">
      <SingleEditObjectMainInfoCompanies :editableLabel="$i18n.tc('Company', 2) + ' *'" :editableInputOptions="allCompanies.data"
      :editingData="editingData" :data="user.company" @update-company="updateCompany($event)"/>
    </div>
    <div v-if="tabs[activeTab].id === 'role'" :style="{ 'height': tabContentHeight }">
      <SingleEditObjectMainInfoRoles :editableLabel="$i18n.tc('Role', 2) + ' *'" :editableInputOptions="allRoles"
      :editingData="editingData" :data="user.role" :roleCompany="user.company.name" @update-roles="updateRole($event)" />
    </div>
    <div v-if="tabs[activeTab].id === 'workspaces'" :style="{ 'height': tabContentHeight }">
      <Table :checkbox="false" :removeTableLines="true" :loading="loading" :headers="headers" :items="workspaceDataFormat" :sortable="true"
        @onScrollBottom="onScrollBottom" @onScrollTop="onScrollTop" @sortClick="onSortClick" :emitRowClickBusEvent="false" />
    </div>
    <div v-if="editingData" class="action-buttons">
      <custom-button :label="$t('Cancel')" :button-color="'#FFF'" :label-color="'#29BDF0'"
        :button-styling="actionButtonsStyling" @buttonClick="$emit('cancel-edit')" />
      <custom-button :label="$t(submitButtonLabel)" :button-color="'#29BDF0'" :label-color="'#FFF'"
        :button-styling="actionButtonsStylingSave" :disabled="!requiredFieldsFilled" @buttonClick="$emit('save-user')" />
    </div>
  </div>
</template>

<script>
import Tabs from '@/newComponents/_Atoms/Tabs.vue';
import CustomButton from '@/newComponents/_Atoms/CustomButton.vue';
import Table from '@/newComponents/_Molecules/Table';
import CustomFieldsTab from '@/newComponents/StockManagement/CustomFieldsTab';
import { mapActions } from "vuex";
import { bus } from "@/main.js";
import { listsMixin } from "@/mixins/listsMixin";
import UserSpecificInfoList from './UserSpecificInfoList.vue';
import SingleEditObjectMainInfoCompanies from "@/newComponents/_Organisms/SingleEditObjectMainInfoCompanies.vue";
import SingleEditObjectMainInfoRoles from "@/newComponents/_Organisms/SingleEditObjectMainInfoRoles.vue";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
export default {
  name: "UserSpecificInfo",

  components: {
    Tabs,
    CustomButton,
    Table,
    CustomFieldsTab,
    UserSpecificInfoList,
    SingleEditObjectMainInfoCompanies,
    SingleEditObjectMainInfoRoles
  },

  mixins: [listsMixin, checkPermissionsMixin],

  props: {
    /**
     * User
     */
    user: {
      type: Object,
      required: true
    },

    editingData: {
      type: Boolean,
      required: true,
    },

    requiredFieldsFilled: {
      type: Boolean,
      required: true,
    },

    submitButtonLabel: {
      type: String,
    },

    customFieldsInputs: {
      type: Array,
    },

    customFieldsValues: {
      type: Object,
    },

    fields: {
      type: Array,
    },

    selectedUser: {
      type: Object,
    },
  },

  data() {
    return {
      activeTab: 0,
      tabsStyling: {
        'margin': '0px 0px 8px 0px',
        'width': '100%',
        'height': '39px',
      },
      tabsLabelsStyling: {
        'text-transform': 'none',
        'font-size': '10px',
        'letter-spacing': '0',
      },
      actionButtonsStyling: {
        'border': '1px solid #29BDF0',
        'border-radius': '7px',
        'font-size': '10px',
        'line-height': '12px',
        'height': '20px',
        'font-weight': '600'
      },
      actionButtonsStylingSave: {
        'font-size': '10px',
        'line-height': '12px',
        'height': '20px',
        'font-weight': '600'
      },
      loading: false,
      pageNumber: 1,
      lastPage: 2,
      companyChosen: true,
      allCompanies: [],
      allRoles: [],
      workspaces: [],
      headers: [
        { text: this.$i18n.tc("Label", 1), varName: "wp_label" },
        { text: this.$i18n.tc("Plan Name", 1), varName: "wp_plan_name" },
        { text: this.$i18n.tc("Phase", 1), varName: "wp_status" },
      ],
    }
  },

  computed: {
    workspaceDataFormat() {
      const formattedWorkspaceData = this.user.workspaces.map(item => {
            item.wp_status = this.getPhaseName(item.wp_status);
            return item;
          });
      
      return formattedWorkspaceData
    },

    cardInfoItemStyling() {
      return {
        'width': this.editingData ? '100%' : 'auto',
        'margin': !this.editingData ? '10px 12px 10px 0' : '6px 9px 6px 0'
      }
    },

    tabContentHeight() {
      return this.editingData ? 'calc(100% - 75px)' : 'calc(100% - 60px)'
    },

    tabs() {
      return [
        {
          id: 'company',
          label: this.$i18n.tc("Company", 2),
        },
        {
          id: 'role',
          label: this.$i18n.tc("Role", 2),
        },
        {
          id: 'workspaces',
          label: this.$i18n.tc("Workspace", 2),
          disabled: this.editingData,
        },
      ]
    },
  },

  mounted(){
    this.getAllCompanies();
    this.getAllWorkspaces();
    this.getProjectPhases();
    this.loadProjectPhases();
    this.updateRoleOptions(this.user.company);
    bus.$on("update-company-bus", (company) => {
      this.user.role = {}
      this.updateRoleOptions(company)
    })
  },

  destroyed() {
    bus.$off("update-company-bus");
  },

  watch: {
    editingData(newValue) {
      if (this.activeTab === 2 && newValue) {
        this.activeTab = 0
      }
    },

    selectedUser(newValue){
      this.updateRoleOptions({id: newValue.company_id});
    }
  },

  methods: {
    ...mapActions(["fetchAllCompanies", "FETCH_ALL_ROLES_PERMISSIONS_LIST", "fetchAllWorkspaces", "fetchCompanyByID"]),

    clearRoles(){
      this.allRoles = [];
    },

    async getAllCompanies() {
      try {
        const response = await this.fetchAllCompanies({ paginate: false });
        if (response.data && response.data.length > 0) {
          this.allCompanies = {
            ...response,
            data: response.data.map(company => ({
              ...company,
              code: company.id
            }))
          };
        } else {
          this.allCompanies = response;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async updateRoleOptions(company) {
      if (Object.keys(company).length === 0 || !company.id) {
        this.allRoles = [];
        return;
      }

      this.companyChosen = false;
      this.loading = true;

      try {
        const result = await this.fetchCompanyByID({ id: company.id, includes: 'roles' });
        const roleHierarchy = ['super-admin', 'admin', 'sub-admin', 'manager', 'user'];

        let currentUserRoleLevel = 'user';
        if (this.isSuperAdmin){
          currentUserRoleLevel = 'super-admin';
        } else if (this.isAdmin) {
          currentUserRoleLevel = 'admin';
        } else if (this.isManager) {
          currentUserRoleLevel = 'manager';
        }

        const currentUserLevelIndex = roleHierarchy.indexOf(currentUserRoleLevel);

        const filteredRoles = result.roles.filter(role => {
          const roleIndex = roleHierarchy.indexOf(role.role_level);
          return roleIndex >= currentUserLevelIndex;
        });

        if (filteredRoles) {
          this.allRoles = filteredRoles.map(role => ({
            ...role,
            code: role.id
          }));
        }

      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    getAllWorkspaces() {
      this.fetchAllWorkspaces({
        fields: "wp_label,wp_plan_name,wp_status"
      })
        .then(workspaces => {
          this.workspaces = workspaces;
          this.workspaces = this.workspaces.map(item => {
            item.wp_status = this.getProjectPhaseName(item.wp_status);
            return item;
          });
        })
        .catch(error => {
          console.error(error);
        })
        .then(() => {
          this.loading = false;
        });
    },

    getProjectPhases() {
      this.projectPhases = this.$store.getters.optionLists_phase;
    },

    loadProjectPhases() {
      let projectPhaseOptions = [];
      let projectPhases = this.$store.getters.optionLists_phase;
      for (const projectPhase of projectPhases) {
        projectPhaseOptions.push({
          text: projectPhase.client_label
            ? projectPhase.client_label
            : projectPhase.libelle,
          value: projectPhase.code,
        });
      }
      this.projectPhaseOptions = projectPhaseOptions;
    },

    getProjectPhaseName(id) {
      if (id && this.workspaces.length > 0) {
        // let phase = this.workspaces.find((item) => item.code === id);
        return this.getListElementLabel(id);
      } else return id;
    },

    async getAllRoles() {
      try {
        const response = await this.FETCH_ALL_ROLES_PERMISSIONS_LIST({ paginate: false, include: 'company' });
        if (response.data.data && response.data.data.length > 0) {
          this.allRoles = {
            ...response,
            data: response.data.data.map(role => ({
              ...role,
              code: role.id
            }))
          };
        } else {
          this.allRoles = response;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    updateCompany(event) {
      this.user.company = event
    },

    updateRole(event) {
      this.user.role = event
    },

    onScrollBottom() {
    },

    onScrollTop() {
    },

    onSortClick(sortOrder, index) {
    },

    getPhaseName(phaseCode){
      const projectPhases = this.$store.getters.optionLists_phase;
      const phase = projectPhases.find(phase => phase.code === phaseCode);
      if(!phase){
        return phaseCode;
      }
      return phase.client_label ? phase.client_label : phase.libelle;
    },

  }
}

</script>

<style scoped>
.material-specific-info-card {
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  padding: 17px 21px;
  flex: 1;
  position: relative;
  height: calc(70% - 8px);
}

.v-tabs>>>.v-tabs-bar {
  height: 39px;
}

.action-buttons {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-end;
  position: absolute;
  right: 21px;
  bottom: 17px;
}

.check-logo {
  height: 11px;
  min-width: 11px;
  ;
}

.table-container {
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/newComponents/Accounts/UserSpecificInfo.vue